import _type from "../type";
var exports = {};
var Type = _type;
exports = new Type("tag:yaml.org,2002:map", {
  kind: "mapping",
  construct: function (data) {
    return data !== null ? data : {};
  }
});
export default exports;